export default "__VITE_ASSET__Bt$Mv$5Y__"